import { motion } from "framer-motion";

import dessert1 from "../../../assets/Desserts/dessert1.jpg";
import dessert2 from "../../../assets/Desserts/dessert2.jpg";
import dessert3 from "../../../assets/Desserts/dessert3.jpg";
import dessert4 from "../../../assets/Desserts/dessert4.jpg";
import dessert5 from "../../../assets/Desserts/dessert5.jpg";
import dessert6 from "../../../assets/Desserts/dessert6.jpg";
import dessert7 from "../../../assets/Desserts/dessert7.jpg";
import dessert8 from "../../../assets/Desserts/dessert8.jpg";

const dessertItems = [
  {
    title: "Cherry bomb",
    price: "₹890",
    img: dessert1,
  },
  {
    title: "Banana split",
    price: "₹950",
    img: dessert2,
  },
  {
    title: "Perfect pancakes",
    price: "₹800",
    img: dessert3,
  },
  {
    title: "Caramel delight",
    price: "₹600",
    img: dessert4,
  },
  {
    title: "Passion on the rocks",
    price: "₹190",
    img: dessert5,
  },
  {
    title: "Matcha toast",
    price: "₹850",
    img: dessert6,
  },
  {
    title: "B & N waffle",
    price: "₹670",
    img: dessert7,
  },
  {
    title: "Banana pizza",
    price: "₹750",
    img: dessert8,
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Desserts = () => {
  return (
    <section className="bg-neutral-100 py-20">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="font-italianno text-primary-800 text-3xl sm:text-4xl">
            Menu
          </span>

          <h2 className="text-primary-700 text-2xl sm:text-3xl xl:text-4xl font-semibold tracking-widest mt-1">
            DESSERTS
          </h2>

          <div className="w-14 h-px bg-primary-400 mx-auto mt-4" />
        </motion.div>

       
        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 xl:gap-8">
          {dessertItems.map((item, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="bg-white overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-48 sm:h-52 xl:h-56 2xl:h-60 object-cover"
              />

              <div className="p-4 xl:p-5 2xl:p-6">
                <div className="flex justify-between items-start gap-2">
                  <h4 className="text-primary-700 font-semibold text-sm xl:text-base leading-snug">
                    {item.title}
                  </h4>

                  <span className="text-primary-800 font-semibold text-sm xl:text-base whitespace-nowrap">
                    {item.price}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Desserts;